import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-inventory",
  "use": "icon-inventory-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 13\" id=\"icon-inventory\"><path fill=\"#fff\" d=\"M0 .5h12v12H0z\" opacity=\".01\" /><path fill=\"#000\" fill-opacity=\".45\" fill-rule=\"evenodd\" d=\"M7.5 2v-.75h-3V2zm-3.715.75V2h-1.91v9.75h8.25V2H8.29v.75h1.085V11h-6.75V2.75zm4.09 2.625v-.75h-3.75v.75zm-1.5 1.5v.75h-2.25v-.75z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol